var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("h2", {
                  staticClass: "text-primary-fh",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.data.dashboard.welcomeHeader + _vm.fullname
                    )
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card dashboard-card" }, [
                  _c("div", { staticClass: "header-wrapper" }, [
                    _c("h2", {
                      staticClass: "text-primary-fh left-header",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.dashboardNoReferral.infoHeader
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.data.dashboardNoReferral.infoTextCardio
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.cardioReferral
                  ? _c("div", { staticClass: "card dashboard-card" }, [
                      _c("p", { staticClass: "text-dark" }, [
                        _c("strong", [_vm._v("Från vårdgivaren")]),
                        _vm._v(":\n            "),
                        _c("br"),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.cardioReferral.decisionText ||
                                "Här kommer meddelande från din vårdgivare att visas"
                            ) +
                            "\n          "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.cardioReferral
                  ? _c("div", { staticClass: "card dashboard-card" }, [
                      _vm._m(0)
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-dark text-center" }, [
      _c("i", [_vm._v("Här kommer meddelande från din vårdgivare att visas")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93a43e2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93a43e2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardCardio.vue
// module id = null
// module chunks = 